import { render, staticRenderFns } from "./FractionDisposalBarChart.vue?vue&type=template&id=1e40f31e&scoped=true&"
import script from "./FractionDisposalBarChart.vue?vue&type=script&lang=js&"
export * from "./FractionDisposalBarChart.vue?vue&type=script&lang=js&"
import style0 from "./FractionDisposalBarChart.vue?vue&type=style&index=0&id=1e40f31e&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1e40f31e",
  null
  
)

export default component.exports